<template>
    <div :class="{'ap': !FEATURE_C2C_LIMIT, 'ap-new': FEATURE_C2C_LIMIT}">
        <scaleArea id="scale" :scales="scales" :selectedNode="selectedNode" ref="scale" @showAllUsers="showAllUsers" @hideAllUsers="hideAllUsers">
        </scaleArea>
        <div v-if="FEATURE_C2C_LIMIT" class="map-container">
            <div id="map" :class="{ 'map-new' : scales.showTimeScale, 'map-full-new' : !scales.showTimeScale}"></div>
            <div v-if="isTalkgroup" class="map-user-list-opener-container">
                <MapUserListOpener @click="handleOnClickMapUserListOpener"/>
            </div>
            <transition name="map-user-list-slide">
                <div v-if="FEATURE_C2C_LIMIT && isTalkgroup && showMapUserList" class="map-user-list-container">
                    <MapUserList
                        @close="handleOnCloseMapUserList"
                        @focus="handleOnFocusUser"
                        :tenantList="tenantList"
                        :users="usersForMapUserList"
                    />
                </div>
            </transition>
        </div>
        <div v-else id="map" :class="{ 'map' : scales.showTimeScale, 'map-full' : !scales.showTimeScale}"></div>
        <div class="menu" id="markerMenu">
            <table width="100%">
                <tr v-if="isMarkerMenuForCurrentTenantUser" class="menu-record">
                    <td class="menu-item">
                        <button
                            class="transparent-button"
                            type="button"
                            v-t="'message.menu_map_icon_change'"
                            @click="handleChangeIcon()"
                        ></button>
                    </td>
                </tr>
                <tr class="menu-record">
                    <td class="menu-item">
                        <button
                            class="transparent-button"
                            type="button"
                            v-t="'message.menu_map_icon_hide'"
                            @click="handleHideIcon()"
                        ></button>
                    </td>
                </tr>
            </table>
        </div>
    </div>
</template>

<script>
import scaleArea from "@/components/ScaleArea"
import server from "@/components/ServerApi.js";
import commonUtil from "@/components/commonutil.js";
import constants from "@/components/constants.js";
import {FEATURE_C2C_LIMIT, FEATURE_C2C_LIMIT_FIX} from "@/components/feature_toggles/feature_toggle";
import MapUserList from "@/components/MapUserList.vue"
import MapUserListOpener from "@/components/MapUserListOpener.vue";

const CLOSE_BOX_URL = 'https://aldio-public.s3.ap-northeast-1.amazonaws.com/web_icon/icon_close.svg';

function CustomMarker(mapComponent, map, showUpdateOnly, locData) {
    this.mapComponent = mapComponent;
    this.showUpdateOnly = showUpdateOnly;
    this.locData = locData;
    this.markerElementList = [];
    this.markerElementByKey = new Map();
    this.DEFAULT_ICON_IMG = `${constants.ICON_IMAGE_PATH}default_marker.png`;
    this.RAF_MODE_IDLE = "IDLE";
    this.RAF_MODE_DRAW = "DRAW";
    this.RAF_MODE_REFRESH = "REFRESH";
    this.markerRafMode = this.RAF_MODE_IDLE;
    this.drawState = {
        generation: 0,
        rafId: null,
        isPending: false,
    };
    this.refreshState = {
        generation: 0,
        rafId: null,
        isPending: false,
    };
    this.map = map;
    this.setMap(map);
}

export default {
    components: {
        MapUserListOpener,
        'scaleArea': scaleArea,
        MapUserList,
    },
    props: {
        appData: Object,
        selectedNode: Object,
        expansionView: Boolean,
        tenantList: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            tabletBrowser: false,
            markerTapTime: null,
            markerIconList: null,
            mapName: "map",
            map: null,
            trafficLayer: null,
            myLatLng: {
                lat: 35.681167,
                lng: 139.767052
            },
            selectedMarker: null,
            markerContextMenu: false,
            time: null,
            lines: [],
            lineMarkers: [],
            scales: {
                range: {
                    min: -10080,
                    max: 0
                },
                disable: true,
                timeRange: {
                    minTime: new Date(),
                    maxTime: new Date()
                },
                changeFlg: false,
                autoUpdateLocationFlg: false,
                showTimeScale: true,
                showTraffic: false,
                updateInterval: 30,
                resetMaxTimeFlg: false,
                now: new Date(),
                trackingLastUpdate: 0,
            },
            acquireTimeRange: {
                minTime: new Date(),
                maxTime: new Date()
            },
            locData: new Map(),
            currentTimeRange: {
                minTime: new Date(),
                maxTime: new Date()
            },
            nameData: new Map(),
            timer: null,
            current_zoom: 8,
            lastGetLocationTime: null,
            maxLocInfo : {
                lat: null,
                lng: null
            },
            minLocInfo : {
                lat: null,
                lng: null
            },
            markerLayer: null,
            userLocCountInDisplayRange: 0,
            latestUserInfo: {
                lat: null,
                lng: null,
                time: null
            },
            changeZoomToAll: false,
            userPanToCenter: false,
            timerObj: null,
            lineMarkerInfoBoxOpened: false,
            infoBoxOfLineMarker: null,
            showMapUserList: false,
            usersForMapUserList: [],
            emergencyUserList: new Set(),
        }
    },
    methods: {
        handleOnClickMapUserListOpener() {
            this.showMapUserList = true;
        },
        handleOnCloseMapUserList() {
            this.showMapUserList = false;
        },
        handleOnFocusUser({tenantId, userId}) {
            if (!this.markerLayer) return;
            this.markerLayer.focusMarker(this.generateUniqueKey(tenantId, userId));
        },
        initMap() {
            if (this.timerObj != null) {
                clearInterval(this.timerObj);
            }
            var this_2 = this;
            this.map = new google.maps.Map(document.getElementById(this.mapName), {
                center: this.myLatLng,
                zoom: this.current_zoom,
                zoomControl: true,
                mapTypeControl: true,
                scaleControl: true,
                streetViewControl: false,
                rotateControl: true,
                fullscreenControl: false,
                styles: [
                  {
                    "featureType": "administrative.land_parcel",
                    "stylers": [
                      {
                        "visibility": "off"
                      }
                    ]
                  },
                  {
                    "featureType": "administrative.neighborhood",
                    "stylers": [
                      {
                        "visibility": "off"
                      }
                    ]
                  },
                  {
                    "featureType": "poi.business",
                    "stylers": [
                      {
                        "visibility": "on"
                      }
                    ]
                  },
                  {
                    "featureType": "poi.park",
                    "elementType": "labels.text",
                    "stylers": [
                      {
                        "visibility": "on"
                      }
                    ]
                  },
                  {
                    "featureType": "road",
                    "elementType": "labels",
                    "stylers": [
                      {
                        "visibility": "on"
                      }
                    ]
                  },
                  {
                    "featureType": "water",
                    "elementType": "labels.text",
                    "stylers": [
                      {
                        "visibility": "on"
                      }
                    ]
                  }
                ]
            });
            this.trafficLayer = new google.maps.TrafficLayer();
        },
        generateUserIdentifierFromLocation(location) {
            return this.generateUniqueKey(location.userTenantId, location.userId);
        },
        generateUserIdentifierFromNode(node) {
            return this.generateUniqueKey(node.data.tenantId, node.data.id);
        },
        generateUniqueKey(tenantId, userId) {
            return `${tenantId}-${userId}`;
        },
        getTenantName(tenantId) {
            const tenantName = this.tenantList.find(t => t.tenantId === tenantId)?.name ?? "";
            return tenantName === "ROOT-NODE" ? "" : tenantName;
        },
        getUserDisplayNameWithTenant(userData) {
            const userName = userData.displayName;
            const tenantName = this.getTenantName(userData.userTenantId);
            return tenantName ? `${userName}@${tenantName}` : userName;
        },
        getRealtimeUserStatus() {
            const endpoint = '/getuserstatus';
            server.post(endpoint)
                .then((res) => {
                    const userStatusMap = res.data.userStatusMap;
                    if (userStatusMap) {
                        Object.entries(userStatusMap).forEach(([userId, userStatus]) => {
                            const numericUserId = Number(userId);

                            if (userStatus.isEmergency) {
                                this.emergencyUserList.add(numericUserId);
                            } else {
                                this.emergencyUserList.delete(numericUserId);
                            }
                        });

                        this.$emit('transmitUserPresences', userStatusMap);
                    }
                })
        },
        async getLocationData(autoUpdate, options = {}) {
            if (!this.map) {
                return;
            }
            if (FEATURE_C2C_LIMIT) {
                this.clearData();
                this.clearLine();
                if (this.isTalkgroup) {
                    // Generally, when showing tracking for a talkgroup,
                    // reuse the overlay since recreating is expensive.
                    if (options.clearOverlay) {
                        // In certain cases, clear the current overlay and create a new one.
                        this.clearMarker();
                    }
                } else if (!autoUpdate) {
                    // When showing tracking for a user,
                    // keep the existing overlay behavior.
                    this.clearMarker();
                }
            } else {
                this.clearData();
                this.clearLine();
                if (!autoUpdate) {
                    // clear marker after getting location data when autoUpdate is true.
                    // because marker will be removed during getting the location data.
                    this.clearMarker();
                }
            }

            if (this.expansionView) {
                this.getRealtimeUserStatus();
            }

            let endpoint;
            let input = {tenantId: this.selectedNode.data.tenantId};

            if (this.isTalkgroup) {
                endpoint = '/getlocationdata';
                input.talkgroupId = this.selectedNode.data.id;
            } else if (this.isNode){
                if (!this.expansionView) {
                    this.usersForMapUserList = [];
                    return;
                }
                endpoint = '/getnodelocationdata';
                input.nodeId = this.selectedNode.data.id;
            } else {
                endpoint = '/getpersonallocationdata';
                input.userId = this.selectedNode.data.id;
                if (autoUpdate) {
                    if (!this.lastGetLocationTime) {
                        let tmpTime = new Date()
                        tmpTime.setSeconds(tmpTime.getSeconds() - this.scales.updateInterval);
                        input.startTime = tmpTime.toISOString();
                    } else {
                        input.startTime = this.lastGetLocationTime.toISOString();
                    }
                    this.lastGetLocationTime = new Date();
                    input.endTime = this.lastGetLocationTime.toISOString();
                    input.needLastLocation = true;
                } else {
                    input.startTime = this.scales.timeRange.minTime.toISOString();
                    input.endTime = this.scales.timeRange.maxTime.toISOString();
                }
            }

            try {
                const res = await server.post(endpoint, input);

                switch (res.data.status) {
                    case constants.STATUS_SUCCESS:
                        if (this.isUser || this.isIpRadio) {
                            this.userLocCountInDisplayRange = res.data.locations.length;
                        }
                        break;
                    case constants.STATUS_ERROR_OBJECT_NOT_FOUND:
                        const value = this.locData.get(this.generateUserIdentifierFromNode(this.selectedNode));
                        if (!value || value.length === 0) {
                            if (this.isTalkgroup || this.isNode) {
                                commonUtil.notifyMessage(this, "Warning", commonUtil.getMessageText(this.$i18n, "error_location_not_found"));
                            } else {
                                if (!autoUpdate) {
                                    const message = commonUtil.getMessageText(this.$i18n, "error_location_not_found_with_time")
                                        .replace('{startTime}', new Date(input.startTime).toLocaleString())
                                        .replace('{endTime}', new Date(input.endTime).toLocaleString());
                                    commonUtil.notifyMessage(this, "Warning", message);
                                }
                            }
                            this.clearMarker();
                        }
                        this.usersForMapUserList = [];
                        return;
                    case constants.STATUS_ERROR_USER_NOT_FOUND:
                        this.usersForMapUserList = [];
                        return;
                    default:
                        this.usersForMapUserList = [];
                        commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_server_api").replace("{functionName}", "getLocationData").replace("{code}", res.data.status));
                        return;
                }
                if (this.isTalkgroup || this.isNode) {
                    this.mergeNameData(res.data.locations, null, null);
                } else {
                    this.mergeNameData(res.data.locations, new Date(input.startTime), new Date(input.endTime));
                }
                this.mergeLocData(res.data.locations);

                this.usersForMapUserList = [];
                for (const [key, userData] of this.nameData.entries()) {
                    const location = this.locData.get(key);
                    if (!location) continue;
                    this.usersForMapUserList.push({...userData, isActive: location[0].update});
                }

                if (FEATURE_C2C_LIMIT) {
                    if (this.isTalkgroup) {
                        if (options.clearOverlay || !this.markerLayer) {
                            this.drawLocation();
                        } else {
                            this.drawLocationPartially();
                        }
                    } else {
                        if (autoUpdate) {
                            this.clearMarker();
                        }
                        this.drawLocation();
                    }
                } else {
                    if (autoUpdate) {
                        this.clearMarker();
                    }
                    this.drawLocation();
                }
            } catch (e) {
                commonUtil.putExceptionErrorMessage(this, "getLocationData", e);
            }
        },
        mergeNameData(locations, startTime, endTime) {
            for (const location of locations) {
                const key = this.generateUserIdentifierFromLocation(location);
                const nameData = this.nameData.get(key);
                if (nameData) {
                    if (FEATURE_C2C_LIMIT_FIX) {
                        nameData.displayName = location.displayName;
                    }
                    nameData.startTime = startTime;
                    nameData.endTime = endTime;
                } else {
                    this.nameData.set(key, {
                        name: location.name,
                        userTenantId: location.userTenantId,
                        userId: location.userId,
                        displayName: location.displayName,
                        marker: location.markerIcon,
                        hide: false,
                        infoWindow: null,
                        infoWindowOpened: false,
                        startTime: startTime,
                        endTime: endTime
                    });
                }
            }
        },
        mergeLocData(locations) {
            const lastUpdateTime = new Date();
            lastUpdateTime.setSeconds(lastUpdateTime.getSeconds() - this.scales.trackingLastUpdate);
            this.maxLocInfo.lat = -90;
            this.maxLocInfo.lng = -180;
            this.minLocInfo.lat = 90;
            this.minLocInfo.lng = 180;

            const locationUpdated = (location) => new Date(location.time).getTime() - lastUpdateTime.getTime() >= 0;
            for (const location of locations) {
                const key = this.generateUserIdentifierFromLocation(location);
                const userData = this.nameData.get(key);
                const updateFlag = locationUpdated(location);

                if (updateFlag) {
                    if(this.expansionView){
                        if (this.isUser || this.isIpRadio) {
                            this.userPanToCenter = true;
                        }
                    }
                }

                if ((this.showUpdateOnly && updateFlag) || !userData.hide) {
                    this.setMinMaxLocInfo(location.lat, location.lng);
                }

                const newLocation = {
                    time: new Date(location.time),
                    lat: location.lat,
                    lng: location.lng,
                    prevLat: location.prevLat,
                    prevLng: location.prevLng,
                    update: updateFlag,
                    inShowRange: true,
                    elapsedTime: 5,
                };

                const userLocationDataList = this.locData.get(key);
                if (!userLocationDataList || userLocationDataList.length === 0) {
                    this.locData.set(key, [newLocation]);
                } else {
                    const prevLoc = userLocationDataList[userLocationDataList.length - 1];
                    newLocation.prevLat = prevLoc.lat;
                    newLocation.prevLng = prevLoc.lng;
                    newLocation.elapsedTime = newLocation.time.getTime() - prevLoc.time.getTime();

                    if (userLocationDataList[0].time.getTime() !== newLocation.time.getTime()) {
                        userLocationDataList.push(newLocation);
                        if (this.isUser && this.scales.autoUpdateLocationFlg) {
                            // delete the data which time is one day older than the latest data when auto updating of user's location data.
                            const minLocationDate = new Date(userLocationDataList[0].time);
                            minLocationDate.setDate(minLocationDate.getDate() - 1);
                            for (let i = 0; i < userLocationDataList.length; i++) {
                                if (new Date(userLocationDataList[i].time).getTime() < minLocationDate.getTime()) {
                                    userLocationDataList.splice(i, 1);
                                }
                            }
                        }
                    } else {
                        // new location data is same as latest location data.
                    }
                }
            }
            if (this.locData.size > 0) {
                for (const location of this.locData.values()) {
                    location.sort((a, b) => b.time.getTime() - a.time.getTime());
                }
                if (this.isUser||this.isIpRadio) {
                    const selectedUserLoc = this.locData.get(this.generateUserIdentifierFromNode(this.selectedNode));
                    if (selectedUserLoc) {
                        this.latestUserInfo.lat = selectedUserLoc[0].lat;
                        this.latestUserInfo.lng = selectedUserLoc[0].lng;
                        this.latestUserInfo.time = selectedUserLoc[0].time;
                    }
                }
            }
        },
        drawInitialLine() {
            const userData = this.nameData.get(this.generateUserIdentifierFromNode(this.selectedNode));
            if (!userData || userData.hide) {
                return false;
            }
            this.locData.forEach((value) => {
                for (let i = 0; i < value.length - 1; i++) {
                    const cur = value[i];
                    const next = value[i + 1];
                    if ((cur.inShowRange) && (next.inShowRange)) {
                        this.drawLine(cur, next, userData);
                        this.setMinMaxLocInfo(cur.lat, cur.lng);
                        this.setMinMaxLocInfo(next.lat, next.lng);
                    }
                }
            });
            return true;
        },
        createMarker: function() {
            this.adjustMapViewport();
            this.markerLayer = new CustomMarker(this, this.map, false, this.locData);
            this.map.addListener("click", () => this.closeMarkerContextMenu());
        },
        adjustMapViewport() {
            if (this.changeZoomToAll) {
                if (this.isTalkgroup || this.isNode) {
                    if (this.existShowMarker()) {
                        // show latest user location in group.
                        if (this.locData.size === 1) {
                            let latLng = new google.maps.LatLng(this.minLocInfo.lat, this.minLocInfo.lng);
                            this.map.setCenter(latLng);
                        } else {
                            let latLngBounds = new google.maps.LatLngBounds(new google.maps.LatLng(this.minLocInfo.lat, this.minLocInfo.lng), new google.maps.LatLng(this.maxLocInfo.lat, this.maxLocInfo.lng));
                            this.map.fitBounds(latLngBounds);
                        }
                    }
                } else {
                    // show tracking location data of specific user.
                    switch (this.userLocCountInDisplayRange) {
                        case 0:
                            // no user data in display range.
                            return;
                        case 1:
                            // only one user data in display range.
                            if (this.existShowMarker()) {
                                let latLng = new google.maps.LatLng(this.minLocInfo.lat, this.minLocInfo.lng);
                                this.map.setCenter(latLng);
                            }
                            break;
                        default:
                            if (this.existShowMarker()) {
                                let latLngBounds = new google.maps.LatLngBounds(new google.maps.LatLng(this.minLocInfo.lat, this.minLocInfo.lng), new google.maps.LatLng(this.maxLocInfo.lat, this.maxLocInfo.lng));
                                this.map.fitBounds(latLngBounds);
                            }
                            break;
                    }
                }
                if (this.markersInNarrowFiled()) {
                    this.map.setZoom(16);
                }
            } else {
                if (this.userPanToCenter) {
                    if(this.expansionView){
                        this.map.panTo(new google.maps.LatLng(this.latestUserInfo.lat, this.latestUserInfo.lng));
                    }else{
                        this.map.panTo(new google.maps.LatLng(this.minLocInfo.lat, this.minLocInfo.lng));
                    }
                    this.userPanToCenter = false;
                }
            }
            this.changeZoomToAll = false;
        },
        initCustomMarkerClass() {
            let locale = "ja-Jp";
            let this_2 = this;

            // inherit google.maps.OverlayView
            CustomMarker.prototype = new google.maps.OverlayView();

            CustomMarker.prototype.onAdd = function () {
                if (this.markerElementList.length > 0) return;
                const panes = this.getPanes();
                if (FEATURE_C2C_LIMIT) {
                    this.cancelMarkerDraw();
                    this.cancelRefreshMarkers();
                    if (this.mapComponent.isTalkgroup) {
                        this.scheduleMarkerDraw();
                    } else {
                        this.mapComponent.locData.forEach((value, key) => this.appendMarkerElement(panes, key, value));
                    }
                } else {
                    this.locData.forEach((value, key) => this.appendMarkerElement(panes, key, value));
                }
            }

            CustomMarker.prototype.appendMarkerElement = function (panes, key, value) {
                if (value.length == 0) {
                    return;
                }
                let userData = this_2.nameData.get(key);

                if (!(this_2.isTalkgroup || this_2.isNode) && !((this_2.isUser || this_2.isIpRadio) && this_2.generateUserIdentifierFromNode(this_2.selectedNode) === key)) {
                    return;
                }

                // get marker icon position from lat/lng
                let timeForInfoWindow
                if (this_2.isTalkgroup || this_2.isNode) {
                    timeForInfoWindow = value[0].time;
                } else {
                    timeForInfoWindow = this_2.latestUserInfo.time;
                }

                let markerElement = document.createElement('div');
                markerElement.id = key

                markerElement.classList.add('marker' + ((value[0].update) ? '' : '--not-updated'));

                        // wrap icon(s) so we can layer overlay image centered atop the base
                        if (this_2.expansionView) {
                            // expansionView true: overlay mode
                            let iconWrapper = document.createElement('div');
                            iconWrapper.classList.add('marker-stack');

                            var icon_img1 = document.createElement('img');
                            icon_img1.classList.add('marker-img');
                            if(this_2.emergencyUserList.has(userData.userId)){
                                icon_img1.src = require('@/assets/icon_expansion/icon_ipRadio_emergency.png');
                            }else if (!userData.marker) {
                                icon_img1.src = this.DEFAULT_ICON_IMG;
                            } else {
                                icon_img1.src = userData.marker;
                            }

                            const userLocation = value[0];
                            const overlayDirection = commonUtil.getDirection16WithElapsed(userLocation.prevLat,userLocation.prevLng,userLocation.lat,userLocation.lng,userLocation.elapsedTime);

                            if (overlayDirection != null) {
                                const overlayUrl = commonUtil.getOverlayUrlForDirection16(overlayDirection);
                                var icon_img2 = document.createElement('img');
                                icon_img2.classList.add('marker-overlay');
                                icon_img2.src = overlayUrl;
                                iconWrapper.appendChild(icon_img2);
                            }

                            iconWrapper.appendChild(icon_img1);

                            let markerInfo = document.createElement('div');
                            markerInfo.id = key + "-info";
                            markerInfo.classList.add('marker-info');
                            markerInfo.innerHTML = userData.displayName;

                            markerElement.appendChild(iconWrapper);
                            markerElement.appendChild(markerInfo);
                        } else {
                            // expansionView false: original single image
                            var icon_img = document.createElement('img');
                            icon_img.classList.add('marker-img');
                            if ((userData.marker == null) || (userData.marker == "")) {
                                icon_img.src = constants.ICON_IMAGE_PATH + "default_marker.png";
                            } else {
                                icon_img.src = userData.marker;
                            }


                            let markerInfo = document.createElement('div');
                            markerInfo.id = key + "-info";
                            markerInfo.classList.add('marker-info');
                            markerInfo.innerHTML = this_2.getUserDisplayNameWithTenant(userData);

                            markerElement.appendChild(icon_img);
                            markerElement.appendChild(markerInfo);
                        }

                        if (((this.showUpdateOnly) && (!value[0].update)) || (userData.hide)) {
                            markerElement.style.display = 'none';
                        }

                // set top/left position
                markerElement.style.position = "absolute";
                // adjust the position of marker icon. move 24px(half size of icon) to upper left
                panes.overlayLayer.appendChild(markerElement);

                if ((this_2.isUser || this_2.isIpRadio) && (!this_2.scales.autoUpdateLocationFlg) && (!userData.hide)) {
                    userData.infoWindow = null;
                    let point = this.getProjection().fromLatLngToDivPixel(new google.maps.LatLng(this_2.latestUserInfo.lat, this_2.latestUserInfo.lng));
                    let latLng = this.getProjection().fromDivPixelToLatLng(new google.maps.Point(point.x - 30, point.y - 24), this.map.getZoom(), true);
                    // set infoBox content (use infobox.js : v3 library)
                    let infoBoxContent = commonUtil.getMessageText(this_2.$i18n, "info_map_marker")
                        .replace("{userName}", this_2.getUserDisplayNameWithTenant(userData))
                        .replace("{time}", timeForInfoWindow.toLocaleString(locale))
                        .replace(/{latitude}/g, this_2.latestUserInfo.lat)
                        .replace(/{longitude}/g, this_2.latestUserInfo.lng);
                    // create infoBox
                    let infoBoxOptions = {
                        content: infoBoxContent,
                        alignBottom: true,
                        position: latLng,
                        pixelOffset: new google.maps.Size(-30, 0),
                        boxClass: "info-box",
                        closeBoxMargin: "8px 0px 0px 0px",
                        closeBoxURL: CLOSE_BOX_URL,
                    };
                    this_2.infoBoxOfLineMarker = new InfoBox(infoBoxOptions);
                    this_2.infoBoxOfLineMarker.open(this_2.map);
                    this_2.lineMarkerInfoBoxOpened = true;
                    google.maps.event.addDomListener(markerElement, 'click', function (events, markerElement) {
                        this_2.infoBoxOfLineMarker.setContent(infoBoxContent);
                        this_2.infoBoxOfLineMarker.setPosition(latLng);
                        this_2.infoBoxOfLineMarker.open(this_2.map);
                        this_2.lineMarkerInfoBoxOpened = true;
                    });
                    google.maps.event.addListener(this_2.infoBoxOfLineMarker, 'closeclick', function (event) {
                        this_2.lineMarkerInfoBoxOpened = false;
                    });
                } else {
                    let point = this.getProjection().fromLatLngToDivPixel(new google.maps.LatLng(value[0].lat, value[0].lng));
                    let latLng = this.getProjection().fromDivPixelToLatLng(new google.maps.Point(point.x - 0, point.y - 0), this.map.getZoom(), true);
                    if (FEATURE_C2C_LIMIT) {
                        const infoBoxContent = commonUtil.getMessageText(this_2.$i18n, "info_map_marker")
                            .replace("{userName}", this_2.getUserDisplayNameWithTenant(userData))
                            .replace("{time}", timeForInfoWindow.toLocaleString(locale))
                            .replace(/{latitude}/g, value[0].lat)
                            .replace(/{longitude}/g, value[0].lng);

                        if (userData.infoWindow == null) {
                            userData.infoWindowOpened = false;
                            if (!FEATURE_C2C_LIMIT_FIX) {
                                google.maps.event.addDomListener(markerElement, 'click', function (_, markerElement) {
                                    if (userData.infoWindow == null) {
                                        // set infoBox content (use infobox.js : v3 library)
                                        let infoBoxOptions = {
                                            content: infoBoxContent,
                                            alignBottom: true,
                                            position: latLng,
                                            pixelOffset: new google.maps.Size(-30, 0),
                                            boxClass: "info-box",
                                            closeBoxMargin: "8px 0px 0px 0px",
                                            closeBoxURL: CLOSE_BOX_URL,
                                            disableAutoPan: true,
                                        };
                                        userData.infoWindow = new InfoBox(infoBoxOptions);
                                        userData.infoWindow.addListener("closeclick", () => {
                                            userData.infoWindowOpened = false;
                                        });
                                    }

                                    userData.infoWindow.open(self.map, markerElement);
                                    userData.infoWindowOpened = true;
                                });
                            }
                        } else {
                            userData.infoWindow.setContent(infoBoxContent);
                            userData.infoWindow.setPosition(latLng);
                        }

                        if (FEATURE_C2C_LIMIT_FIX) {
                            google.maps.event.addDomListener(markerElement, 'click', function (_, markerElement) {
                                if (userData.infoWindow == null) {
                                    // set infoBox content (use infobox.js : v3 library)
                                    let infoBoxOptions = {
                                        content: infoBoxContent,
                                        alignBottom: true,
                                        position: latLng,
                                        pixelOffset: new google.maps.Size(-30, 0),
                                        boxClass: "info-box",
                                        closeBoxMargin: "8px 0px 0px 0px",
                                        closeBoxURL: CLOSE_BOX_URL,
                                        disableAutoPan: true,
                                    };
                                    userData.infoWindow = new InfoBox(infoBoxOptions);
                                    userData.infoWindow.addListener("closeclick", () => {
                                        userData.infoWindowOpened = false;
                                    });
                                }

                                userData.infoWindow.open(self.map, markerElement);
                                userData.infoWindowOpened = true;
                            });
                        }
                    } else {
                        let infoBoxContent = commonUtil.getMessageText(this_2.$i18n, "info_map_marker")
                            .replace("{userName}", this_2.getUserDisplayNameWithTenant(userData))
                            .replace("{time}", timeForInfoWindow.toLocaleString(locale))
                            .replace(/{latitude}/g, value[0].lat)
                            .replace(/{longitude}/g, value[0].lng);

                        if (userData.infoWindow == null) {
                            // set infoBox content (use infobox.js : v3 library)
                            // create infoBox
                            let infoBoxOptions = {
                                content: infoBoxContent,
                                alignBottom: true,
                                position: latLng,
                                pixelOffset: new google.maps.Size(-30, 0),
                                boxClass: "info-box",
                                closeBoxMargin: "8px 0px 0px 0px",
                                closeBoxURL: CLOSE_BOX_URL,
                                disableAutoPan: true,
                            };
                            userData.infoWindow = new InfoBox(infoBoxOptions);
                            userData.infoWindowOpened = false;
                        } else {
                            userData.infoWindow.setContent(infoBoxContent);
                            userData.infoWindow.setPosition(latLng);
                        }
                        google.maps.event.addDomListener(markerElement, 'click', function (events, markerElement) {
                            userData.infoWindow.open(self.map, markerElement);
                            userData.infoWindowOpened = true;
                        });
                        userData.infoWindow.addListener("closeclick", function (argument) {
                            userData.infoWindowOpened = false;
                        });
                    }
                }

                let self = this;
                panes.overlayMouseTarget.appendChild(markerElement);
                google.maps.event.addDomListener(markerElement, 'contextmenu', function (events) {
                    self.mapComponent.showMarkerDialog(userData, event);
                });
                this.markerElementList.push(markerElement);
                this.markerElementByKey.set(key, markerElement);
            }

            CustomMarker.prototype.focusMarker = function (key) {
                const location = this.mapComponent.locData.get(key);
                const markerElement = this.markerElementByKey.get(key);
                if (!location || !markerElement) return;

                markerElement.click();
                this.map.setCenter(new google.maps.LatLng(location[0].lat, location[0].lng));
                if (this.map.getZoom() < 10) {
                    this.map.setZoom(10);
                }
            }

            // draw marker layer. It will be called on drawing or moving or zooming
            CustomMarker.prototype.draw = function () {
                const bounds = this.map.getBounds();
                if (FEATURE_C2C_LIMIT) {
                    this.mapComponent.locData.forEach((value, key) => this.updateMarker(bounds, key, value));
                } else {
                    this.locData.forEach((value, key) => this.updateMarker(bounds, key, value));
                }
            }

            CustomMarker.prototype.updateMarker = function (bounds, key, value) {
                if (value.length === 0) {
                    return;
                }
                let userData = this_2.nameData.get(key);

                if (FEATURE_C2C_LIMIT && this.mapComponent.isTalkgroup) {
                    const markerElement = this.markerElementByKey.get(key) ?? document.getElementById(key);
                    const hide = () => markerElement.style.display = "none";
                    const show = () => markerElement.style.display = null;
                    const updateClassName = () => {
                        markerElement.classList.remove(value[0].update ? "marker--not-updated" : "marker");
                        markerElement.classList.add(value[0].update ? "marker" : "marker--not-updated");
                    };
                    if (markerElement) {
                        if (userData.hide) {
                            hide();
                            userData.infoWindow?.close?.();
                            return;
                        }

                        if (bounds && !bounds.contains(new google.maps.LatLng(value[0].lat, value[0].lng))) {
                            hide();
                            userData.infoWindow?.close?.();
                            return;
                        } else {
                            show();
                            updateClassName();
                        }
                    }
                }

                // get marker icon position from lat/lng
                let point;
                let showMarker = false;
                if (this_2.isUser || this_2.isIpRadio) {
                    if (userData.userId == this_2.selectedNode.data.id) {
                        if (userData.infoWindow != null) {
                            userData.infoWindow.setContent(commonUtil.getMessageText(this_2.$i18n, "info_map_marker")
                                .replace("{userName}", this_2.getUserDisplayNameWithTenant(userData))
                                .replace("{time}", this_2.latestUserInfo.time.toLocaleString(locale))
                                .replace(/{latitude}/g, value[0].lat)
                                .replace(/{longitude}/g, value[0].lng));
                        }
                        point = this.getProjection().fromLatLngToDivPixel(new google.maps.LatLng(this_2.latestUserInfo.lat, this_2.latestUserInfo.lng));
                        showMarker = true;
                    }
                } else {
                    if (FEATURE_C2C_LIMIT_FIX) {
                        if (userData.infoWindow != null) {
                            userData.infoWindow.setContent(commonUtil.getMessageText(this_2.$i18n, "info_map_marker")
                                .replace("{userName}", this_2.getUserDisplayNameWithTenant(userData))
                                .replace("{time}", value[0].time.toLocaleString(locale))
                                .replace(/{latitude}/g, value[0].lat)
                                .replace(/{longitude}/g, value[0].lng));
                        }
                    }
                    point = this.getProjection().fromLatLngToDivPixel(new google.maps.LatLng(value[0].lat, value[0].lng));
                    showMarker = true;
                }
                if (showMarker) {
                    if (userData.infoWindowOpened) {
                        // adjust the position of infoWindow when it has opened.
                        let latLng = this.getProjection().fromDivPixelToLatLng(new google.maps.Point(point.x - 80, point.y - 24), this.map.getZoom(), true);
                        userData.infoWindow.setPosition(latLng);
                    }
                    let markerElement;
                    if (FEATURE_C2C_LIMIT) {
                        markerElement = this.markerElementByKey.get(key) ?? document.getElementById(key);
                    } else {
                        markerElement = document.getElementById(key);
                    }
                    if (markerElement != null) {
                        // adjust the position of marker icon. move 24px(half size of icon) to upper left
                        markerElement.style.left = (point.x - 24) + 'px';
                        markerElement.style.top = (point.y - 24) + 'px';

                        if (FEATURE_C2C_LIMIT && this.mapComponent.isTalkgroup) {
                            const markerImg = markerElement.querySelector(".marker-img");
                            const markerImgSrc = userData.marker || this.DEFAULT_ICON_IMG;
                            if (markerImg && markerImg.src !== markerImgSrc) {
                                markerImg.src = markerImgSrc;
                            }
                        }
                    }
                }
                if (this_2.lineMarkerInfoBoxOpened) {
                    point = this.getProjection().fromLatLngToDivPixel(new google.maps.LatLng(this_2.latestUserInfo.lat, this_2.latestUserInfo.lng));
                    let latLng = this.getProjection().fromDivPixelToLatLng(new google.maps.Point(point.x - 80, point.y - 24), this.map.getZoom(), true);
                    this_2.infoBoxOfLineMarker.setPosition(latLng);
                }
            }

            CustomMarker.prototype.refresh = function () {
                this.scheduleMarkerRefresh();
            }

            CustomMarker.prototype.scheduleMarkerDraw = async function () {
                if (this.markerRafMode === this.RAF_MODE_DRAW) return;
                if (this.markerRafMode === this.RAF_MODE_REFRESH) {
                    this.drawState.isPending = true;
                    return;
                }

                const myGen = this.updateDrawGeneration();
                const CHUNK_SIZE = 300;
                const panes = this.getPanes();
                const iterator = this.mapComponent.nameData.keys();

                const cleanup = () => {
                    this.drawState.rafId = null;
                    this.markerRafMode = this.RAF_MODE_IDLE;
                    if (this.refreshState.isPending) {
                        this.refreshState.isPending = false;
                        this.scheduleMarkerRefresh();
                    }
                };
                const loop = () => {
                    if (!this.isDrawStillValid(myGen)) {
                        cleanup();
                        return;
                    }

                    let remaining = CHUNK_SIZE;
                    const bounds = this.map.getBounds();
                    while (remaining-- > 0) {
                        const {value: key, done} = iterator.next();

                        if (done) {
                            cleanup();
                            return;
                        } else {
                            const location = this.mapComponent.locData.get(key);
                            if (location?.length > 0) {
                                this.appendMarkerElement(panes, key, location);
                                this.updateMarker(bounds, key, location);
                            }
                        }
                    }
                    this.drawState.rafId = requestAnimationFrame(loop);
                };

                this.cancelMarkerDraw();
                this.markerRafMode = this.RAF_MODE_DRAW;

                // Avoid blocking initial map rendering.
                await new Promise(resolve => setTimeout(resolve, 500));

                if (this.isDrawStillValid(myGen)) {
                    this.drawState.rafId = requestAnimationFrame(loop);
                } else {
                    cleanup();
                }
            }

            CustomMarker.prototype.scheduleMarkerRefresh = function () {
                if (this.markerRafMode === this.RAF_MODE_REFRESH) return;
                if (this.markerRafMode === this.RAF_MODE_DRAW) {
                    this.refreshState.isPending = true;
                    return;
                }

                const panes = this.getPanes();
                if (!panes) {
                    this.markerRafMode = this.RAF_MODE_IDLE;
                    return;
                }

                const myGen = this.updateRefreshGeneration();
                const CHUNK_SIZE = 100;
                const iterator = this.mapComponent.nameData.keys();

                const cleanup = () => {
                    this.refreshState.rafId = null;
                    this.markerRafMode = this.RAF_MODE_IDLE;
                    if (this.drawState.isPending) {
                        this.drawState.isPending = false;
                        this.scheduleMarkerDraw();
                    }
                };
                const loop = () => {
                    if (!this.isRefreshStillValid(myGen)) {
                        cleanup();
                        return;
                    }

                    let remaining = CHUNK_SIZE;
                    const bounds = this.map.getBounds();
                    while (remaining-- > 0) {
                        const {value: key, done} = iterator.next();
                        if (done) {
                            cleanup();
                            return;
                        } else {
                            const location = this.mapComponent.locData.get(key);
                            if (!location || location.length === 0) {
                                this.markerElementList = this.markerElementList.filter(e => e.id !== key);
                                this.markerElementByKey.get(key)?.remove?.();
                                this.markerElementByKey.delete(key);
                                continue;
                            }
                            if (this.markerElementByKey.has(key)) {
                                this.updateMarker(bounds, key, location);
                            } else {
                                this.appendMarkerElement(panes, key, location);
                            }
                        }
                    }
                    this.refreshState.rafId = requestAnimationFrame(loop);
                };

                this.cancelRefreshMarkers();
                this.markerRafMode = this.RAF_MODE_REFRESH;
                this.refreshState.rafId = requestAnimationFrame(loop);
            }

            CustomMarker.prototype.isDrawStillValid = function (gen) {
                if (gen !== this.drawState.generation) return false;
                return this.getMap();
            }

            CustomMarker.prototype.isRefreshStillValid = function (gen) {
                if (gen !== this.refreshState.generation) return false;
                return this.getMap();
            }

            CustomMarker.prototype.cancelMarkerDraw = function () {
                if (this.drawState.rafId !== null) {
                    cancelAnimationFrame(this.drawState.rafId);
                    this.drawState.rafId = null;
                }
                if (this.markerRafMode === this.RAF_MODE_DRAW) {
                    this.markerRafMode = this.RAF_MODE_IDLE;
                }
            }

            CustomMarker.prototype.cancelRefreshMarkers = function () {
                if (this.refreshState.rafId !== null) {
                    cancelAnimationFrame(this.refreshState.rafId);
                    this.refreshState.rafId = null;
                }
                if (this.markerRafMode === this.RAF_MODE_REFRESH) {
                    this.markerRafMode = this.RAF_MODE_IDLE;
                }
            }

            CustomMarker.prototype.removeAllMarkerElements = function () {
                if (!this.markerElementList.length) return;
                this.markerElementList.forEach(e => e.remove());
                this.markerElementList = [];
                this.markerElementByKey.clear();
            }

            // remove marker from layer
            if (FEATURE_C2C_LIMIT) {
                CustomMarker.prototype.onRemove = function () {
                    this.removeAllMarkerElements();
                }
                CustomMarker.prototype.updateDrawGeneration = function () {
                    return ++this.drawState.generation;
                }
                CustomMarker.prototype.updateRefreshGeneration = function () {
                    return ++this.refreshState.generation;
                }
            } else {
                CustomMarker.prototype.remove = function () {
                    if (this.markerElementList.length > 0) {
                        for (let markerElement of this.markerElementList) {
                            markerElement.parentNode.removeChild(markerElement);
                        }
                        this.markerElementList = [];
                        this.markerElementByKey.clear();
                    }
                }
            }

            CustomMarker.prototype.clearLayer = function () {
                if (FEATURE_C2C_LIMIT) {
                    this.updateDrawGeneration();
                    this.updateRefreshGeneration();
                    this.cancelMarkerDraw();
                    this.cancelRefreshMarkers();
                    this.removeAllMarkerElements();
                }
                this.setMap(null);
            }
        },
        showAllUsers: function() {
            if (FEATURE_C2C_LIMIT) {
                return;
            }

            if (this.markerLayer == null) {
                return;
            }
            for (let markerElement of this.markerLayer.markerElementList) {
                // cause click event
                markerElement.click();
            }
        },
        hideAllUsers: function() {
            if (FEATURE_C2C_LIMIT) {
                return;
            }

            if (!this.markerLayer) {
                return;
            }
            for (const markerElement of this.markerLayer.markerElementList) {
                const userData = this.nameData.get(markerElement.id);
                if (!userData?.infoWindow || !userData?.infoWindowOpened) {
                    continue;
                }
                userData.infoWindow.close();
                userData.infoWindowOpened = false;
            }
        },
        drawLine: function(location1, location2, userData) {
            let fromLocation = new google.maps.LatLng(location1.lat, location1.lng);
            let toLocation = new google.maps.LatLng(location2.lat, location2.lng);
            let locale = "ja-Jp";

            var lineSymbol = {
                path: google.maps.SymbolPath.BACKWARD_CLOSED_ARROW,
                scale: 3,
            };
            var line = new google.maps.Polyline({
                path: [{
                    lat: location1.lat,
                    lng: location1.lng
                }, {
                    lat: location2.lat,
                    lng: location2.lng
                }],
                strokeColor: 'rgba(61, 125, 211, 1)',
                strokeWeight: 3,
                icons: [{
                    icon: {
                        path: google.maps.SymbolPath.BACKWARD_CLOSED_ARROW,
                        scale: 3,
                    },
                    offset: '0',
                }],
                map: this.map,
            });
            // color of marker on line sets to transparent
            // position of marker is same as arrow-icon on line
            // markers use to show infoBox(update time) by click
            var lineMarkerSymbol = {
                path: google.maps.SymbolPath.CIRCLE,
                strokeColor: 'rgba(0, 0, 0, 0)',
                scale: 4,
            }
            var marker = new google.maps.Marker({
                position: new google.maps.LatLng(location2.lat ,location2.lng),
                map: this.map,
                icon: lineMarkerSymbol
            });

            let infoBoxContent = commonUtil.getMessageText(this.$i18n,"info_map_marker")
                .replace("{userName}", this.getUserDisplayNameWithTenant(userData))
                .replace("{time}", location2.time.toLocaleString(locale))
                .replace(/{latitude}/g, location2.lat)
                .replace(/{longitude}/g, location2.lng);

            let self = this;
            marker.addListener( "click", function ( event ) {
                // infoBox of marker on line will move (and change content) when other marker has clicked.
                self.infoBoxOfLineMarker.setContent(infoBoxContent);
                self.infoBoxOfLineMarker.setPosition(marker.getPosition());
                if (!self.lineMarkerInfoBoxOpened) {
                    self.lineMarkerInfoBoxOpened = true;
                    self.infoBoxOfLineMarker.open(self.map, marker);
                }
            } ) ;
            // lines and linkMarkers will be saved for clearing process
            this.lines.push(line);
            this.lineMarkers.push(marker);
        },
        closeMarkerContextMenu() {
            if (this.markerContextMenu) {
                let markerMenu = document.getElementById("markerMenu");
                markerMenu.style.display = "none";
                this.markerContextMenu = false;
            }
        },
        clearMarker: function() {
            if (this.markerLayer != null) {
                this.markerLayer.clearLayer();
            }
        },
        closeInfoWindowOfUser(uniqueId) {
            const userData = this.nameData.get(uniqueId);
            if (userData?.infoWindow && userData?.infoWindowOpened) {
                userData.infoWindow.close();
                userData.infoWindowOpened = false;
            }
        },
        clearLine: function() {
            for (var i = 0; i < this.lines.length; i++) {
                this.lines[i].setMap(null);
            }
            this.lines = [];
            for (var i = 0; i < this.lineMarkers.length; i++) {
                this.lineMarkers[i].setMap(null);
            }
            this.lineMarkers = [];
            if (this.lineMarkerInfoBoxOpened) {
                this.infoBoxOfLineMarker.close();
                this.lineMarkerInfoBoxOpened = false;
            }
            this.infoBoxOfLineMarker = null;
        },
        drawLocation: function() {
            if (this.isUser || this.isIpRadio) {
                if (!this.drawInitialLine()) {
                    return;
                }
            }
            this.createMarker();
        },
        drawLocationPartially() {
            if (!this.markerLayer) return;
            this.adjustMapViewport();
            this.markerLayer.refresh();
        },
        trimTime: function(date_1, date_2) {
            this.locData.forEach((value, key) => {
                for (var loc = value.length - 1; loc >= 0; loc--) {
                    if (date_1 < value[loc].time && value[loc].time < date_2) {
                        value[loc].inShowRange = false;
                    }
                }
            });
        },
        personalDataModify: function() {
            this.userLocCountInDisplayRange = 0;
            let self = this;
            this.locData.forEach((value, key) => {
                for (var loc = value.length - 1; loc >= 0; loc--) {
                    if (self.scales.timeRange.minTime < value[loc].time && value[loc].time < self.scales.timeRange.maxTime) {
                        value[loc].inShowRange = true;
                        self.latestUserInfo.lat = value[loc].lat;
                        self.latestUserInfo.lng = value[loc].lng;
                        self.latestUserInfo.time = value[loc].time;
                        self.userLocCountInDisplayRange ++;
                    } else {
                        value[loc].inShowRange = false;
                    }
                }
            });
            this.currentTimeRange.maxTime = new Date(this.scales.timeRange.maxTime);
            this.currentTimeRange.minTime = new Date(this.scales.timeRange.minTime);
        },
        setScalesRange: function() {
            this.acquireTimeRange.maxTime = new Date(this.scales.now);
            this.acquireTimeRange.minTime = new Date(this.scales.now);
            this.currentTimeRange.maxTime = new Date(this.scales.now);
            this.currentTimeRange.minTime = new Date(this.scales.now);
            let minute = this.scales.now.getMinutes();
            this.acquireTimeRange.maxTime.setMinutes(minute + this.scales.range.max);
            this.acquireTimeRange.minTime.setMinutes(minute + this.scales.range.min);
            this.currentTimeRange.maxTime.setMinutes(minute + this.scales.range.max);
            this.currentTimeRange.minTime.setMinutes(minute + this.scales.range.min);
        },
        clearData: function() {
            this.maxLocInfo.lat = -90;
            this.maxLocInfo.lng = -180;
            this.minLocInfo.lat = 90;
            this.minLocInfo.lng = 180;
            this.locData = new Map();
        },
        changeActiveTalker: function (newNode, oldNode) {
            this.latestUserLocation = null;
            this.scales.disable = false;
            this.scales.autoUpdateLocationFlg = true;
            if (this.isTalkgroup || this.isNode) {
                this.changeZoomToAll = true;
            } else {
                this.userPanToCenter = true;
            }
            if (this.showMapUserList
                && newNode.data.type === constants.OBJECT_TALKGROUP
                && oldNode.data.type === constants.OBJECT_TALKGROUP
            ) {
                // keep opening
            } else {
                this.showMapUserList = false;
            }

            this.acquireTimeRange.maxTime = this.currentTimeRange.maxTime;
            this.acquireTimeRange.minTime = this.currentTimeRange.minTime;

            const nodeChanged = newNode !== oldNode;
            const options = {clearOverlay: nodeChanged};
            this.getLocationData(this.scales.autoUpdateLocationFlg, options);
            if (this.scales.autoUpdateLocationFlg) {
                this.setTimer();
            }
        },
        setTimer: function() {
            this.scales.disable = true;
            if (this.timer != null) {
                clearInterval(this.timer);
                this.timer = null;
            }
            this.timer = setInterval(this.updateLocationByTimer, this.scales.updateInterval * 1000);
        },
        changeRange() {
            const savedMaxLocInfo = {...this.maxLocInfo};
            const savedMinLocInfo = {...this.minLocInfo};
            const userData = this.nameData.get(this.generateUserIdentifierFromNode(this.selectedNode));
            const hasRequiredData = userData?.startTime
                && userData?.endTime
                && userData.startTime.getTime() <= new Date(this.scales.timeRange.minTime).getTime()
                && userData.endTime.getTime() >= new Date(this.scales.timeRange.maxTime).getTime();

            this.scales.changeFlg = false;
            this.latestUserInfo = {};
            this.maxLocInfo.lat = -90;
            this.maxLocInfo.lng = -180;
            this.minLocInfo.lat = 90;
            this.minLocInfo.lng = 180;
            if (hasRequiredData) {
                // change show range
                this.clearLine();
                this.clearMarker();
                this.personalDataModify(); // latestUserInfo is updated here
                switch (this.userLocCountInDisplayRange) {
                    case 0:
                        this.maxLocInfo = savedMaxLocInfo;
                        this.minLocInfo = savedMinLocInfo;
                        this.$notify({
                            title: 'Warning',
                            message: commonUtil.getMessageText(this.$i18n, "error_location_not_found"),
                            type: 'warning'
                        });
                        return;
                    case 1:
                        this.maxLocInfo.lat = this.minLocInfo.lat = this.latestUserInfo.lat;
                        this.maxLocInfo.lng = this.minLocInfo.lng = this.latestUserInfo.lng;
                        break;
                    default:
                        break;
                }
                this.drawLocation();
            } else {
                this.getLocationData(false);
            }
        },
        updateLocation: function() {
            this.scales.now = new Date();
            this.getLocationData(this.scales.autoUpdateLocationFlg);
        },
        updateLocationByTimer() {
            this.scales.now = new Date();
            this.getLocationData(this.scales.autoUpdateLocationFlg);
        },
        setMinMaxLocInfo(lat, lng) {
            if (this.maxLocInfo.lat == -90) {
                this.maxLocInfo.lat = lat;
            } else {
                this.maxLocInfo.lat = Math.max(this.maxLocInfo.lat, lat);
            }
            if (this.maxLocInfo.lng == -180) {
                this.maxLocInfo.lng = lng;
            } else {
                this.maxLocInfo.lng = Math.max(this.maxLocInfo.lng, lng);
            }
            if (this.minLocInfo.lat == 90) {
                this.minLocInfo.lat = lat;
            } else {
                this.minLocInfo.lat = Math.min(this.minLocInfo.lat, lat);
            }
            if (this.minLocInfo.lng == 180) {
                this.minLocInfo.lng = lng;
            } else {
                this.minLocInfo.lng = Math.min(this.minLocInfo.lng, lng);
            }
        },
        markersInNarrowFiled() {
            // check the distance between 2 locations
            let lat1 = this.minLocInfo.lat * Math.PI / 180;
            let lng1 = this.minLocInfo.lng * Math.PI / 180;
            let lat2 = this.maxLocInfo.lat * Math.PI / 180;
            let lng2 = this.maxLocInfo.lng * Math.PI / 180;
            let distance = 6371 * Math.acos(Math.cos(lat1) * Math.cos(lat2) * Math.cos(lng2 - lng1) + Math.sin(lat1) * Math.sin(lat2));
            if (distance < 1) {
                // 2 locations are close when distance is smaller than 1km (zoom up the map)
                return true;
            } else {
                return false;
            }
        },
        handleChangeIcon() {
            this.closeMarkerContextMenu();
            if ((this.selectedMarker.marker == null) || ((this.selectedMarker.marker == ""))) {
                this.$emit('showMarkerIconList',this.selectedMarker.displayName, null);
            } else {
                this.$emit('showMarkerIconList',this.selectedMarker.displayName, this.selectedMarker.marker);
            }
        },
        handleHideIcon() {
            this.closeMarkerContextMenu();
            const key = this.generateUserIdentifierFromLocation(this.selectedMarker);
            const userData = this.nameData.get(key);
            if (userData) {
                userData.hide = true;
                userData.infoWindow?.close?.();
                userData.infoWindowOpened = false;
            }
            const markerElement = document.getElementById(key);
            if (markerElement) {
                markerElement.style.display = "none";
            }
            this.updateLocation();
            commonUtil.notifyMessage(this, "Warning", commonUtil.getMessageText(this.$i18n, "info_map_icon_hided").replace("{userName}", this.selectedMarker.displayName));
        },
        async changeMarkerIcon(iconUrl) {
            const param = {userId: this.selectedMarker.userId, iconUrl: iconUrl};
            if (iconUrl === "") {
                param.resetIcon = true;
            }
            try {
                const res = await server.post("/setmarkericon", param);
                switch(res.data.status) {
                    case constants.STATUS_SUCCESS:
                        const userData = this.nameData.get(this.generateUserIdentifierFromLocation(this.selectedMarker));
                        if (userData) {
                            userData.marker = iconUrl;
                        }
                        this.updateLocation();
                        commonUtil.notifyMessage(this, "Success", commonUtil.getMessageText(this.$i18n, "info_map_icon_changed"));
                        break;
                    case constants.STATUS_ERROR_INVALID_PARAMETER:
                        commonUtil.notifyMessage(this, "Warning", commonUtil.getMessageText(this.$i18n, "error_invalid_icon_fileName"));
                        break;
                    default:
                        commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_server_api").replace("{functionName}", "changeMarkerIcon").replace("{code}", res.data.status));
                        break;
                }
            } catch (e) {
                commonUtil.putExceptionErrorMessage(this, "changeMarkerIcon", e);
            }
        },
        showMarkerDialog(userData, event) {
            let userAgent = window.navigator.userAgent.toLowerCase();
                // edge and firefox doesn't support TouchEvent
                let eventFired;
                if ((userAgent.indexOf('edge') >= 0) || (userAgent.indexOf('msie') >= 0) || (userAgent.indexOf('trident') >= 0)) {
                    eventFired = (event instanceof MouseEvent);
                } else if (userAgent.indexOf('chrome') >= 0) {
                    eventFired = (event instanceof MouseEvent) || (event[prop] instanceof TouchEvent);
                } else {
                    eventFired = (event instanceof MouseEvent);
                }
                if (eventFired) {
                    let mouseEvt = event;
                    mouseEvt.preventDefault();

                    let markerMenu = document.getElementById("markerMenu");
                    if (this.tabletBrowser) {
                        markerMenu.style.left = mouseEvt.changedTouches[0].clientX + "px";
                        markerMenu.style.top = mouseEvt.changedTouches[0].clientY + "px";
                    } else {
                        markerMenu.style.left = mouseEvt.clientX + "px";
                        markerMenu.style.top = mouseEvt.clientY + "px";
                    }
                    markerMenu.style.display = "block";

                    this.selectedMarker = userData;
                    this.markerContextMenu = true;
                }
        },
        handleChangeMarkerDisplayStatus(newSelectedNode) {
            // close infoWindow of current selected node.
            switch(this.selectedNode.data.type) {
                case constants.OBJECT_USER:
                case constants.OBJECT_IP_RADIO:
                    const currentUserData = this.nameData.get(this.generateUserIdentifierFromNode(this.selectedNode));
                    if (currentUserData != null && currentUserData.infoWindowOpened) {
                        currentUserData.infoWindow.close();
                        currentUserData.infoWindowOpened = false;
                    }
                    break;
                case constants.OBJECT_TALKGROUP:
                case constants.OBJECT_NODE:
                    for (const currentUserNode of this.selectedNode.childNodes) {
                        const currentUserData = this.nameData.get(this.generateUserIdentifierFromNode(currentUserNode));
                        if (currentUserData != null && currentUserData.infoWindowOpened) {
                            currentUserData.infoWindow.close();
                            currentUserData.infoWindowOpened = false;
                        }
                    }
                    break;
            }
            // reset hide flag of new selected node.
            switch(newSelectedNode.data.type) {
                case constants.OBJECT_USER:
                case constants.OBJECT_IP_RADIO:
                    const newUserData = this.nameData.get(this.generateUserIdentifierFromNode(newSelectedNode));
                    if (newUserData != null) {
                        newUserData.hide = false;
                    }
                    break;
                case constants.OBJECT_TALKGROUP:
                case constants.OBJECT_NODE:
                    for (const newUserNode of newSelectedNode.childNodes) {
                        const newUserData = this.nameData.get(this.generateUserIdentifierFromNode(newUserNode));
                        if (newUserData != null) {
                            newUserData.hide = false;
                        }
                    }
                    break;
            }
            if (this.selectedNode === newSelectedNode) {
                // redraw the markers when clicked already selected object.
                this.updateLocation();
            }
            this.$refs.scale.handleChangeMarkerDisplayStatus();
        },
        existShowMarker() {
            // there are no shown marker when min-lat = 90 (initial value)
            return (this.minLocInfo.lat != 90)
        },
    },
    created() {
        this.markerIconList = commonUtil.getMarkerIconList();
        let userAgent = window.navigator.userAgent.toLowerCase();
        if ((userAgent.indexOf("android") >= 0) ||
            (userAgent.indexOf("ipad") >= 0)) {
            this.tabletBrowser = true;
        }
    },
    mounted() {
        this.timerObj = setInterval(() => {
            // should not call initMap until google script has loaded
            if (window.google?.maps?.Map) {
                clearInterval(this.timerObj);
                this.timerObj = null;

                const infoBoxScript = document.createElement('script')
                infoBoxScript.setAttribute('src', '../js/infobox_packed.js')
                document.head.appendChild(infoBoxScript)
                this.initMap();
                this.initCustomMarkerClass();
            }
        }, 200);
        this.setScalesRange();
    },
    watch: {
        'selectedNode': function (newVal, oldVal) {
            this.changeActiveTalker(newVal, oldVal);
        },
        'scales.changeFlg': function(range) {
            if (this.scales.changeFlg) {
                this.changeRange();
            }
        },
        'scales.showTraffic': function(bool) {
            if (this.scales.showTraffic) {
                this.trafficLayer.setMap(this.map);
            } else {
                this.trafficLayer.setMap(null);
            }
        },
        'scales.autoUpdateLocationFlg'() {
            if (this.scales.autoUpdateLocationFlg) {
                if (this.isUser || this.isIpRadio) {
                    this.changeZoomToAll = false;
                    this.getLocationData(true);
                }
                this.setTimer();
            } else {
                if (this.timer != null) {
                    clearInterval(this.timer);
                    this.timer = null;
                }
                if (this.isUser || this.isIpRadio) {
                    this.changeZoomToAll = true;
                    this.scales.disable = false;
                    this.closeInfoWindowOfUser(this.generateUserIdentifierFromNode(this.selectedNode));
                    this.getLocationData(false);
                }
            }
        },
        'scales.updateInterval': function(int) {
            if (this.timer != null) {
                clearInterval(this.timer);
                this.timer = null;
                this.timer = setInterval(this.updateLocationByTimer, this.scales.updateInterval * 1000);
            }
            this.trackingLastUpdate = this.scales.updateInterval * 2 + 10;
        },
        '$i18n.locale': function(value) {
            location.hash = "#/map"
            location.reload();
        },
        '$route' (to, from) {
            if (to.name == "Map") {
                if (this.scales.autoUpdateLocationFlg) {
                    this.setTimer()
                }
            }
            if (from.name == "Map") {
                clearInterval(this.timer);
                this.timer = null;

                if (this.timerObj) {
                    clearInterval(this.timerObj);
                }

                if (FEATURE_C2C_LIMIT) {
                    if (this.markerLayer) {
                        this.markerLayer.updateDrawGeneration();
                        this.markerLayer.updateRefreshGeneration();
                    }
                }
            }
        },
        'expansionView': function(expansionView) {
            if (this.selectedNode && this.selectedNode.data) {
                this.updateLocation();
            }
        }
    },
    computed: {
        FEATURE_C2C_LIMIT() {
            return FEATURE_C2C_LIMIT;
        },
        isNode: function() {
            if (this.selectedNode == null) {
                return false;
            }
            return (this.selectedNode.data.type == constants.OBJECT_NODE) ;
        },
        isTalkgroup: function() {
            if (this.selectedNode == null) {
                return false;
            }
            return (this.selectedNode.data.type == constants.OBJECT_TALKGROUP) ;
        },
        isUser: function() {
            if (this.selectedNode == null) {
                return false;
            }
            return (this.selectedNode.data.type == constants.OBJECT_USER) ;
        },
        isIpRadio: function() {
            if (this.selectedNode == null) {
                return false;
            }
            return (this.selectedNode.data.type == constants.OBJECT_IP_RADIO) ;
        },
        isMarkerMenuForCurrentTenantUser() {
            if (this.selectedMarker?.userTenantId === undefined) {
                return false;
            }
            if (this.appData.tenantList?.[0]?.tenantId === undefined) {
                return false;
            }
            return this.selectedMarker?.userTenantId === this.appData.tenantList?.[0]?.tenantId;
        },
    }
}
</script>
<style>
.ap {
    position: relative;
    height: 100%;
    width: 100%;
}

.map {
    position: relative;
    box-sizing: border-box;
    height: calc(100% - 173px);
    width: 100%;
}
.map-full {
    position: relative;
    box-sizing: border-box;
    height: calc(100% - 115px);
    width: 100%;
}

#scale {
    max-height: 140px;
    width: 100%;
    position: relative;
    top: 0px;
    left: 0px;
    padding-bottom: 10px;
}

.menu {
    width: 170px;
    box-shadow: 3px 3px 5px #888888;
    border-style: solid;
    border-width: 1px;
    border-color: grey;
    border-radius: 2px;
    position: fixed;
    display: none;
}
.menu-record {
    background-color: white;
}
.menu-record:hover {
    background-color: #ecf1fa;
    cursor: pointer;
}
.menu-item {
    font-size: 12px;
    padding: 5px 10px;
    display: block;
}

.marker--not-updated {
	-webkit-filter: grayscale(1); /* Webkit */
	filter: gray; /* IE6-9 */
	filter: grayscale(1); /* W3C */
}

.marker-info {
    position: absolute;
    width: max-content;
    text-align: center;
    top: 50px;
    left: -5px;
    display: none;
    opacity: 0;
    padding: 5px;
    border-radius: 5px;
    color: #000;
    background-color: #fff;
    animation-duration: 0.3s;
    animation-name: show-marker-info;
}

img.marker-img {
    width: 48px;
    height: 48px;
}

.marker-img:hover + .marker-info {
    display: inline-block;
    opacity: 1;
    top: 50px;
}

.marker-info::before {
    content: "";
    position: absolute;
    bottom: 97%;
    left: 20px;
    border: 6px solid transparent;
    border-bottom: 6px solid white;
}

/* stacked marker icons */
.marker-stack {
  position: relative;
  display: inline-block;
  width: 48px;
  height: 48px;
}

.marker-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
}

/* image1 (small, top) */
.marker-stack .marker-img {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 60%;
  height: 60%;
}

/* 既存の .marker-img:hover に加えて、stack 上でも反応させる */
.marker-stack:hover + .marker-info {
  display: inline-block;
  opacity: 1;
  top: 50px;
}

@keyframes show-marker-info {
    0% {
        display: none;
        opacity: 0;
        top: 30px;
    }
    1% {
        display: inline-block;
        opacity: 0;
        top: 30px;
    }
    100% {
        display: inline-block;
        opacity: 1;
        top: 50px;
    }
}

.info-box {
    background-color: #5171cb
}
.info-box-title {
    color:#fff;
    padding: 4px 0px 4px 10px;
    display: block;
    font-size: 14px;
}
.info-box-table {
    background-color: #fff;
    color: #000;
}

button.transparent-copy-button {
    border: 1px solid #5171cb;
    border-radius: 5px;
    color: #5171cb;
    background-color: transparent;
    cursor: pointer;
    outline: 0;
    margin: 4px 8px 2px 8px;
    padding: 2px 8px;
    font-size: 8px;
    font-weight: bold;
    white-space:nowrap;
}
button.transparent-copy-button:active {
    background-color: #5171cb;
    opacity: 0.5;
}

</style>

<style scoped>
.ap-new {
    position: relative;
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
}

.map-container {
    flex-grow: 1;
    position: relative;
    box-sizing: border-box;
    width: 100%;
}

.map-new {
    position: relative;
    box-sizing: border-box;
    height: 100%;
    width: 100%;
}

.map-full-new {
    position: relative;
    box-sizing: border-box;
    height: 100%;
    width: 100%;
}

.map-user-list-opener-container {
    position: absolute;
    top: 12px;
    right: 12px;
    z-index: 10;

    &:hover {
        cursor: pointer;
    }
}

.map-user-list-container {
    position: absolute;
    top: 0;
    right: 0;
    height: 100%;
    width: 320px;
    z-index: 10;
    background-color: #ffffff;
    box-shadow: -4px 4px 4px rgba(0, 0, 0, 0.3);
    will-change: transform;
}

/* Vue transition classes */
.map-user-list-slide-enter-active {
    transition: 150ms ease-out;
}

.map-user-list-slide-leave-active {
    transition: 150ms ease-in;
}

.map-user-list-slide-enter,
.map-user-list-slide-leave-to {
    transform: translateX(100%);
}

.map-user-list-slide-enter-to,
.map-user-list-slide-leave {
    transform: translateX(0);
}
</style>
